export enum BookButtonDataHooks {
  ACTION_BUTTON = 'booking-details-action-button',
  SPINNER = 'booking-details-spinner',
}
